import { createContext } from "react";
import { defaultExtendedPermissions, defaultFunctionPermissions } from "../helpers/rolesToPermissions";

export const editableUseCasePermissions = [
    "PU.SOPO-P.001",
    "PU.SOPO-P.005",
    "PU.SOPO-P.016",
    "PU.SOPO-P.021",
    "PU.SOPO-P.024",
    "PU.SOPO-P.028",
    "PU.SOPO-P.029",
    "PU.SOPO-P.030",
    "PU.SOPO-P.045",
    "PU.SOPO-P.046",
    "PU.SOPO-P.049",
    "PU.SOPO-P.061",
    "PU.SOPO-P.063",
    "PU.SOPO-P.071",
    "PU.SOPO-P.076",
    "PU.SOPO-P.077"
]

type SharedProps = {
    id: number
}

export type UseCase = SharedProps & {
    koD_PU: string,
    nazwA_PU: string
}

export type PortalGroup = SharedProps & {
    nazwa: string
}

export type RoleDefinition = SharedProps & {
    przypadeK_UZYCIA_ID: number,
    portaL_GRUPA_ID: number
}

export type UseCaseDefinitions = {
    useCase: UseCase,
    portalGroups: PortalGroup[]
}

export type FunctionType = {
    active: boolean,
    useCaseCode: string
}

export type FunctionTypes = {
    onlineFunction: FunctionType, // Przejdź do trybu online                                               (PU.SOPO-P.001)
    loginFunction: FunctionType, // Wyświetl okno logowania do systemu                                     (PU.SOPO-P.002)
    userNotifications: FunctionType, // Wyświetl komunikaty dla użytkownika                                (PU.SOPO-P.004)
    offlineFunction: FunctionType, // Przejdź do trybu offline                                             (PU.SOPO-P.005)
    processN: FunctionType, // Dodaj nowe osuwisko / teren zagrożony (proces N)                            (PU.SOPO-P.009)
    addGeometry: FunctionType, // Dodaj geometrię do KR                                                    (PU.SOPO-P.010)
    processA: FunctionType, // Aktualizuj osuwisko / teren zagrożony (proces A)                            (PU.SOPO-P.011)
    browseDataBase: FunctionType, // Przeglądaj wszystkie KR w bazie głównej                               (PU.SOPO-P.016)
    verifyKR: FunctionType, // Weryfikuj KR                                                                (PU.SOPO-P.019)
    browseUserKRPOWaitingTab: FunctionType, // Przeglądaj przypisane KR/PO w poczekalni                    (PU.SOPO-P.020)
    editCollectivelyKR: FunctionType, // Edytuj zbiorczo KR                                                (PU.SOPO-P.021)
    assignVerifier: FunctionType, // Przypisz weryfikatora do KR                                           (PU.SOPO-P.022)
    assignEditor: FunctionType, // Przypisz edytora do KR                                                  (PU.SOPO-P.023)
    cancelEditTaskProcessOAndK: FunctionType, // Anuluj zadanie edycji (proces O, K)                       (PU.SOPO-P.024)
    processO: FunctionType, // Dodaj nową KRO/KRTZ (proces O)                                              (PU.SOPO-P.028)   
    processK: FunctionType, // Przygotuj KR do edycji (proces K)                                           (PU.SOPO-P.029)
    downloadKRPOToEdit: FunctionType, // Pobierz KR/PO na komputer osobisty (do edycji)                    (PU.SOPO-P.030)
    returnKRPO: FunctionType, // Zwróć KR/PO do do poczekalni                                              (PU.SOPO-P.032)
    updateOfDataBase: FunctionType, // Aktualizacja bazy głównej                                           (PU.SOPO-P.033)  
    sendNotifications: FunctionType, // Wyślij powiadomienia                                               (PU.SOPO-P.034) 
    userConfig: FunctionType, // Ustaw opcje użytkownika                                                   (PU.SOPO-P.036)
    runAutomaticVerification: FunctionType, // Uruchom weryfikację automatyczną                            (PU.SOPO-P.037)
    sendMessages: FunctionType, // Wyślij wiadomość do użytkownika                                         (PU.SOPO-P.039)                  
    cancelProcessAAndN: FunctionType, // Anuluj dodanie/aktualizację obiektu (proces N,A)                  (PU.SOPO-P.041)
    deleteKRAndRelativeObjects: FunctionType, // Kasuj KR i związane obiekty                               (PU.SOPO-P.042)
    downloadKRForVerification: FunctionType, // Pobierz KR na komputer osobisty (do weryfikacji)           (PU.SOPO-P.044)
    EditPO: FunctionType, // Edytuj PO                                                                     (PU.SOPO-P.045)
    EditKR: FunctionType, // Edytuj KR                                                                     (PU.SOPO-P.046)
    browseKRPOInLocalBase: FunctionType, // Przeglądaj pobrane KR/PO w bazie lokalnej                      (PU.SOPO-P.047)
    browseAllKRPOWaitingTab: FunctionType, // Przeglądaj wszystkie KR/PO w poczekalni                      (PU.SOPO-P.049)
    addPO: FunctionType, // Dodaj protokół obserwacji                                                      (PU.SOPO-P.061)
    correctPO: FunctionType, // Koryguj protokół obserwacji                                                (PU.SOPO-P.063)
    configureNotifications: FunctionType, // Konfiguruj powiadomienia                                      (PU.SOPO-P.070)
    proposeNewDictValue: FunctionType, // Zgłoś propozycję nowej wartości słownikowej                      (PU.SOPO-P.071)
    editDicts: FunctionType, // Edytuj słowniki                                                            (PU.SOPO-P.072)
    acceptRejectDictProposals: FunctionType, // Zatwierdź lub odrzuć propozycję dodania pozycji słownika   (PU.SOPO-P.073)
    configurePermissions: FunctionType, // Zarządzaj uprawnieniami                                         (PU.SOPO-P.074) 
    spacialAnalyses: FunctionType, // Analizy przestrzenne                                                 (PU.SOPO-P.075)                                                    
    showObjGeomOnMap: FunctionType, // Wyświetl geometrię obiektu na mapie                                 (PU.SOPO-P.076)
    pointObjOnMap: FunctionType, // Wskaż obiekt na mapie                                                  (PU.SOPO-P.077)

    markKRComplete: FunctionType, // Oznacz KR 'Kompletna'
    markKRToBeCorrected: FunctionType, // Oznacz KR 'Do poprawy'
    markKRAccepted: FunctionType, // Oznacz KR 'Zatwierdzona'
    markPOAccepted: FunctionType, // Oznacz PO 'Zatwierdzona'
    markKRNoGeom: FunctionType, // Oznacz KR 'Oczekuje na geometrię'
}

export type ExtendedUserPermissions = {
    userObjectCategories?: any[],
    userPowiaty?: any[],
    userGminy?: any[],
    success?: boolean
}

const PermissionsContext = createContext({
    functionsPermissions: defaultFunctionPermissions(),
    setFunctionsPermissions: (functions: FunctionTypes) => { },
    extendedUserPermissions: defaultExtendedPermissions(),
    setExtendedUserPermissions: (functions: ExtendedUserPermissions) => { }
})

export default PermissionsContext